import { render, staticRenderFns } from "./DeatilsImage.vue?vue&type=template&id=5b7c1e59&"
import script from "./DeatilsImage.vue?vue&type=script&lang=js&"
export * from "./DeatilsImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports